import TwoDayDeliveryBadge from "@/components/two-day-delivery-badge/twoDayDeliveryBadge";

interface Props {
  message?: JSX.Element;
  isVendorPicker?: boolean;
  twoDayBadgeTooltipPosition?: "top" | "bottom";
}

export const TwoDayDeliveryAbTest = ({ message, isVendorPicker, twoDayBadgeTooltipPosition }: Props) => {
  return (
    <>
      <span className="standardShippingVariation">& {message}</span>
      <span className="twoDayDeliveryVariation">
        <TwoDayDeliveryBadge
          size="1x"
          visible={true}
          isVendorPicker={isVendorPicker}
          tooltipPlacement={twoDayBadgeTooltipPosition}
        />
      </span>
    </>
  );
};
